<select
  [id]="id"
  [ngModel]="value()"
  (ngModelChange)="onSelectChange($event)"
  [disabled]="disabled"
>
  <option value="">{{ placeholder }}</option>
  @for (s of usStates; track s.code) {
    <option [value]="s.code" [title]="s.name">{{ s.code }} – {{ s.name }}</option>
  }
</select>
